<app-collapsible-section
  title="User Segment"
  [isExpanded]="isExpanded"
  [isCompleted]="isCompleted"
  [showDoneButton]="true"
  (toggle)="onUserSegmentToggle($event)"
  (done)="onUserSegmentDone()"
>
  <ng-template #sectionContent>
    <!-- Error Message -->
    <div *ngIf="showError" class="error-message">Choose a user segment for your campaign.</div>

    <!-- Search Bar -->
    <div class="search-container">
      <div class="search-input-wrapper">
        <svg class="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
            stroke="#9CA3AF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14 14L11.1 11.1"
            stroke="#9CA3AF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <input
          type="text"
          class="search-input"
          placeholder="Search by segment name"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange()"
        />
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading segments...</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && filteredSegments.length === 0" class="empty-state">
      <div class="empty-state-content">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="24" cy="24" r="24" fill="#F3F4F6" />
          <path
            d="M24 16C20.6863 16 18 18.6863 18 22C18 25.3137 20.6863 28 24 28C27.3137 28 30 25.3137 30 22C30 18.6863 27.3137 16 24 16Z"
            fill="#9CA3AF"
          />
          <path
            d="M24 30C18.4772 30 14 34.4772 14 40H34C34 34.4772 29.5228 30 24 30Z"
            fill="#9CA3AF"
          />
        </svg>
        <h3>No segments found</h3>
        <p>No segments match your search criteria.</p>
      </div>
    </div>

    <!-- Segments List -->
    <div class="segments-container" *ngIf="!isLoading && filteredSegments.length > 0">
      <div class="segments-list">
        <div
          *ngFor="let segment of filteredSegments; trackBy: trackByIndex"
          class="segment-card"
          [class.selected]="segment.selected"
        >
          <div class="segment-content">
            <div class="segment-info">
              <h3 class="segment-name">{{ segment.name }}</h3>
              <p class="segment-description">{{ segment.description }}</p>
              <div class="customer-count">
                <svg
                  width="12"
                  height="11"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_62325_90220)">
                    <path
                      d="M5.84961 6.68446C7.42121 6.68446 11.0996 6.68454 11.0996 9.90223C11.0979 10.0364 11.044 10.1648 10.9492 10.2597C10.8544 10.3545 10.7259 10.4082 10.5918 10.41C10.4576 10.4083 10.3293 10.3545 10.2344 10.2597C10.1395 10.1648 10.0848 10.0364 10.083 9.90223C10.083 8.58129 9.36537 7.70106 5.84961 7.70106C2.33384 7.70106 1.61623 8.58129 1.61621 9.90223C1.61621 10.037 1.56208 10.1663 1.4668 10.2616C1.37153 10.3568 1.24212 10.41 1.10742 10.41C0.972766 10.41 0.843268 10.3568 0.748047 10.2616C0.65286 10.1663 0.599609 10.0369 0.599609 9.90223C0.599644 6.68454 4.278 6.68446 5.84961 6.68446ZM5.35449 0.636608C5.84701 0.53873 6.35734 0.589047 6.82129 0.781139C7.28547 0.97341 7.68278 1.29893 7.96191 1.71669C8.24099 2.13438 8.38961 2.62548 8.38965 3.12782C8.38965 3.80155 8.12191 4.44829 7.64551 4.92469C7.16914 5.40085 6.52316 5.66786 5.84961 5.66786C5.34722 5.66786 4.85621 5.51921 4.43848 5.24012C4.02084 4.96107 3.69522 4.56449 3.50293 4.10048C3.31069 3.63636 3.26044 3.12541 3.3584 2.6327C3.45642 2.13993 3.69844 1.68719 4.05371 1.33192C4.40897 0.976699 4.86176 0.734619 5.35449 0.636608ZM5.84961 1.6034C5.54827 1.6034 5.25352 1.69288 5.00293 1.86024C4.75228 2.02772 4.55677 2.2663 4.44141 2.54481C4.32608 2.8233 4.29569 3.13004 4.35449 3.42567C4.41333 3.72119 4.55843 3.99286 4.77148 4.20594C4.98465 4.41911 5.25707 4.56412 5.55273 4.62294C5.84819 4.68161 6.1543 4.65126 6.43262 4.53602C6.71113 4.42066 6.94971 4.22515 7.11719 3.9745C7.28453 3.72392 7.37402 3.42915 7.37402 3.12782C7.37398 2.72383 7.21328 2.33643 6.92773 2.05067C6.64189 1.76483 6.25385 1.60341 5.84961 1.6034Z"
                      fill="#0030A8"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_62325_90220">
                      <rect
                        width="10.5"
                        height="10.5"
                        fill="white"
                        transform="translate(0.599609 0.25)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <span class="count-text">{{ segment.customerCount }} CUSTOMERS</span>
              </div>
            </div>
            <div class="checkbox-container">
              <mat-checkbox
                [(ngModel)]="segment.selected"
                [checked]="true"
                (change)="onSegmentChange()"
                (click)="$event.stopPropagation()"
              >
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer">
      <div class="footer-left">
        <span class="selection-count"
          ><span class="count-number">{{ selectedCount }}</span> customers selected</span
        >
      </div>

      <div class="footer-right">
        <button class="btn btn-tertiary btn-medium" (click)="createNewSegment()">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="20" fill="#F8F8FC" />
            <path
              d="M10 2.25C10.4142 2.25003 10.75 2.58584 10.75 3V9.25H17C17.4142 9.25006 17.75 9.58584 17.75 10C17.75 10.4142 17.4142 10.7499 17 10.75H10.75V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58583 17.75 9.25002 17.4142 9.25 17V10.75H3C2.58579 10.75 2.25 10.4142 2.25 10C2.25001 9.5858 2.58579 9.25 3 9.25H9.25V3C9.25004 2.58585 9.58585 2.25004 10 2.25Z"
              fill="#15172E"
            />
          </svg>
          New Segment
        </button>
        <button class="btn btn-primary btn-medium" (click)="onUserSegmentDone()">Done</button>
      </div>
    </div>
  </ng-template>
</app-collapsible-section>

<!-- Add Segment Modal -->
<app-add-segment-modal
  *ngIf="showAddSegmentModal"
  [isEditMode]="false"
  [segmentToEdit]="null"
  [campaignPlatform]="primaryCampaignPlatform"
  (close)="onCloseAddSegmentModal()"
  (save)="onSaveSegment($event)"
>
</app-add-segment-modal>
